"use client";
import React from "react";
import Link from "next/link";
import CustomButton from "../Buttons/CustomButton";
import Image from "next/image";
import AllwaysknowPay from "@/Helper/images/always-know-what-you-pay.svg";
import ContactourSalesprofessionals from "@/Helper/images/contact-our-sales-professionals.svg";
import "./GetReady.css";
import { usePathname } from "next/navigation";

const GetReady = () => {
  const pathname = usePathname();

  return (
    <section
      className={pathname === "/" ? "getreadywhite get_ready_container" : "get_ready_container"}
    >
      <div className="container">
        <div className="get_readymid">
          <div className="get_readylft">
            <p className="get_head">Turn your data into actionable insights?</p>
            <p className="get_desc">
            Empower your business &amp; drive success with our advanced BI and analytics solutions.
            </p>
            <Link aria-label="Start now" href="/contact-us">
              <CustomButton Text="Get Started" btn-primary-primary />
            </Link>
          </div>
          <div className="get_readyright">
            <div className="get_readyrgtinner">
              {/* <div className="get_rgtbx">
                <Image src={AllwaysknowPay} alt="Always know what you pay" />
                <label>Always know what you pay</label>
                <p>
                  Integrated per-transaction <br />
                  pricing with no hidden fees.
                </p>
                <Link aria-label="Pricing details" href="/pricing">
                  Pricing details
                  <svg
                    width="8"
                    height="10"
                    viewBox="0 0 8 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.88965 1L5.88965 5L1.88965 9"
                      stroke="CurrentColor"
                      strokeWidth="2"
                    />
                  </svg>
                </Link>
              </div> */}
              <div className="get_rgtbx">
                <Image
                  src={ContactourSalesprofessionals}
                  alt="Contact our sales professionals"
                />
                <label>Contact our sales professionals</label>
                <p>
                  Connect with our experts for <br />
                  personalized assistance.
                </p>
                <Link aria-label="Contact sales" href="/contact-us">
                Contact Us 
                  <svg
                    width="8"
                    height="10"
                    viewBox="0 0 8 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.88965 1L5.88965 5L1.88965 9"
                      stroke="CurrentColor"
                      strokeWidth="2"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetReady;
